<div class="chat-passport" [class.chat-passport--locked]="locked">
  @if (showLabel) {
    <div class="chat-passport__label">
      Passport details for {{ passengerName }}
      @if (isMandatory) {
        <span class="chat-passport__required" aria-hidden="true">*</span>
      }
    </div>
  }

  @if (locked && chosenSummary === 'Skipped') {
    <div class="chat-passport__chosen">{{ chosenSummary }}</div>
  }

  @if (hasSavedPassports) {
    <select
      class="chat-passport__control"
      aria-label="Saved passports"
      [disabled]="locked"
      (change)="onDropdownChange($any($event.target).value)"
    >
      @for (saved of savedPassports; track saved.id) {
        <option [value]="saved.id" [selected]="selectedId === idToString(saved.id)">
          {{ formatSavedPassport(saved) }}
        </option>
      }
      <option [value]="NONE_ID" [selected]="selectedId === NONE_ID">None</option>
    </select>
  }

  @if (showManualEntry) {
    <div class="chat-passport__manual">
      @if (hasField('passportNumber')) {
        <label class="chat-passport__field-wrap chat-passport__field-wrap--full">
          <span class="chat-passport__field-label">Passport Number</span>
          <input
            type="text"
            aria-label="Passport number"
            [disabled]="locked"
            [(ngModel)]="passportNumber"
            placeholder="e.g. GB1234567"
          />
        </label>
      }

      <div class="chat-passport__row">
        @if (hasField('dateOfBirth')) {
          <label class="chat-passport__field-wrap">
            <span class="chat-passport__field-label">Date of birth</span>
            <input
              type="date"
              aria-label="Date of birth"
              [disabled]="locked"
              [(ngModel)]="dateOfBirth"
            />
          </label>
        }
        @if (hasField('dateOfIssue')) {
          <label class="chat-passport__field-wrap">
            <span class="chat-passport__field-label">Date of issue</span>
            <input
              type="date"
              aria-label="Date of issue"
              [disabled]="locked"
              [(ngModel)]="dateOfIssue"
            />
          </label>
        }
      </div>

      <div class="chat-passport__row">
        @if (hasField('dateOfExpiry')) {
          <label class="chat-passport__field-wrap">
            <span class="chat-passport__field-label">Expiry Date</span>
            <input
              type="date"
              aria-label="Expiry date"
              [disabled]="locked"
              [(ngModel)]="dateOfExpiry"
            />
          </label>
        }
        @if (hasField('gender')) {
          <label class="chat-passport__field-wrap">
            <span class="chat-passport__field-label">Gender</span>
            <select aria-label="Gender" [disabled]="locked" [(ngModel)]="gender">
              <option [ngValue]="null">None</option>
              <option [ngValue]="'M'">Male</option>
              <option [ngValue]="'F'">Female</option>
            </select>
          </label>
        }
      </div>

      @if (hasField('passportCountry')) {
        <label class="chat-passport__field-wrap chat-passport__field-wrap--full">
          <span class="chat-passport__field-label">Passport country</span>
          <select aria-label="Passport country" [disabled]="locked" [(ngModel)]="passportCountry">
            <option [ngValue]="''">None</option>
            @for (country of searchService.countries; track country.cCode) {
              <option [ngValue]="country.tCode">{{ country.cName }}</option>
            }
          </select>
        </label>
      }

      @if (hasField('nationality')) {
        <label class="chat-passport__field-wrap chat-passport__field-wrap--full">
          <span class="chat-passport__field-label">Nationality</span>
          <select aria-label="Nationality" [disabled]="locked" [(ngModel)]="nationality">
            <option [ngValue]="''">None</option>
            @for (country of searchService.countries; track country.cCode) {
              <option [ngValue]="country.tCode">{{ country.cName }}</option>
            }
          </select>
        </label>
      }

      @if (hasField('codeOfIssuingState')) {
        <label class="chat-passport__field-wrap chat-passport__field-wrap--full">
          <span class="chat-passport__field-label">Issuing State Code</span>
          <select
            aria-label="Issuing state code"
            [disabled]="locked"
            [(ngModel)]="codeOfIssuingState"
          >
            <option [ngValue]="''">None</option>
            @for (country of searchService.countries; track country.cCode) {
              <option [ngValue]="country.tCode">{{ country.cName }}</option>
            }
          </select>
        </label>
      }
    </div>
  }

  <div class="chat-passport__actions">
    @if (!isMandatory) {
      <button type="button" class="chat-passport__skip" [disabled]="locked" (click)="onSkip()">
        Skip
      </button>
    }
    <button
      type="button"
      class="chat-passport__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
